import { io } from 'socket.io-client';

// "undefined" means the URL will be computed from the `window.location` object
const URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://constemsai.azurewebsites.net';

console.log('Node Env', process.env.NODE_ENV, window.location.hostname, URL, process.env.PORT)
export const socket = io(URL, {
  secure: true,
  transports: ["websocket"] // HTTP long-polling is disabled
});